export default "__VITE_ASSET__DDlnkWit__"